import { SoundController } from "@hg/media"

import { bgm } from "./bgm"
import { sfx } from "./sfx"
import { STORAYGE_KEY_MUTE } from "@/const"

export const getIsMute = () => !localStorage.getItem(STORAYGE_KEY_MUTE)
export const setMusicMute = () => localStorage.setItem(STORAYGE_KEY_MUTE, "1")
export const unsetMusicMute = () => localStorage.removeItem(STORAYGE_KEY_MUTE)

export const soundController = new SoundController({
    initEnable: getIsMute(),
    sounds: [bgm, sfx],
})
